import { apiSlice } from "../api/apiSlice";

export const dashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWeatherDashboardData: builder.query({
      query: () => "/apiV2/weather-dashboard",
    }),
    // updateDeviceConfigList: builder.mutation({
    //   query: (data) => ({
    //     url: "/apiV2/devices-config",
    //     method: "POST",
    //     body: data,
    //   }),
    //   invalidatesTags: ["deviceConfig"],
    // }),
  }),
});

export const {
  useGetWeatherDashboardDataQuery,
  useLazyGetWeatherDashboardDataQuery,
} = dashboardApi;
